/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TermsOfServiceImport } from './routes/terms-of-service'
import { Route as PrivacyPolicyImport } from './routes/privacy-policy'
import { Route as PaymentProcessorPolicyImport } from './routes/payment-processor-policy'
import { Route as LandingRouteImport } from './routes/_landing/route'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated/route'
import { Route as LandingPaymentSuccessfulImport } from './routes/_landing/payment-successful'
import { Route as LandingPaymentFailedImport } from './routes/_landing/payment-failed'
import { Route as AuthenticatedSubscribedRouteImport } from './routes/_authenticated/_subscribed/route'
import { Route as LandingPricingIndexImport } from './routes/_landing/pricing/index'
import { Route as LandingIndexIndexImport } from './routes/_landing/_index/index'
import { Route as AuthenticatedPatreonIndexImport } from './routes/_authenticated/patreon/index'
import { Route as AuthenticatedSubscribedHudImport } from './routes/_authenticated/_subscribed/hud'
import { Route as AuthenticatedSubscribedAdminImport } from './routes/_authenticated/_subscribed/admin'
import { Route as AuthenticateSignUpSplatImport } from './routes/_authenticate/sign-up.$'
import { Route as AuthenticateSignInSplatImport } from './routes/_authenticate/sign-in.$'
import { Route as AuthenticatedSubscribedPlayRouteImport } from './routes/_authenticated/_subscribed/play/route'
import { Route as AuthenticatedSubscribedMainRouteImport } from './routes/_authenticated/_subscribed/_main/route'
import { Route as AuthenticatedPatreonSignupIndexImport } from './routes/_authenticated/patreon/signup/index'
import { Route as AuthenticatedSubscribedMainSettingsImport } from './routes/_authenticated/_subscribed/_main/settings'
import { Route as AuthenticatedSubscribedMainMyGamesImport } from './routes/_authenticated/_subscribed/_main/my-games'
import { Route as AuthenticatedSubscribedMainMyGameGeneratorsImport } from './routes/_authenticated/_subscribed/_main/my-game-generators'
import { Route as AuthenticatedSubscribedMainMetronomeImport } from './routes/_authenticated/_subscribed/_main/metronome'
import { Route as AuthenticatedSubscribedMainExploreScriptsImport } from './routes/_authenticated/_subscribed/_main/explore-scripts'
import { Route as AuthenticatedSubscribedMainExploreGamesImport } from './routes/_authenticated/_subscribed/_main/explore-games'
import { Route as AuthenticatedSubscribedMainExploreGameGeneratorsImport } from './routes/_authenticated/_subscribed/_main/explore-game-generators'
import { Route as AuthenticatedSubscribedScriptScriptIdRouteImport } from './routes/_authenticated/_subscribed/script.$scriptId/route'
import { Route as AuthenticatedSubscribedMainGameGeneratorRouteImport } from './routes/_authenticated/_subscribed/_main/game-generator/route'
import { Route as AuthenticatedSubscribedScriptScriptIdIndexImport } from './routes/_authenticated/_subscribed/script.$scriptId/index'
import { Route as AuthenticatedSubscribedPlayGameGeneratorIndexImport } from './routes/_authenticated/_subscribed/play/game-generator/index'
import { Route as AuthenticatedSubscribedMainSubscriptionIndexImport } from './routes/_authenticated/_subscribed/_main/subscription/index'
import { Route as AuthenticatedSubscribedMainMyScriptsIndexImport } from './routes/_authenticated/_subscribed/_main/my-scripts/index'
import { Route as AuthenticatedSubscribedMainHomeIndexImport } from './routes/_authenticated/_subscribed/_main/home/index'
import { Route as AuthenticatedSubscribedMainGameGeneratorIndexImport } from './routes/_authenticated/_subscribed/_main/game-generator/index'
import { Route as AuthenticatedSubscribedMainGameBuilderIndexImport } from './routes/_authenticated/_subscribed/_main/game-builder/index'
import { Route as AuthenticatedSubscribedScriptScriptIdDialogImport } from './routes/_authenticated/_subscribed/script.$scriptId/dialog'
import { Route as AuthenticatedSubscribedPlayGameGeneratorGameGeneratorIdImport } from './routes/_authenticated/_subscribed/play/game-generator/$gameGeneratorId'
import { Route as AuthenticatedSubscribedPlayCustomGameGameIdImport } from './routes/_authenticated/_subscribed/play/custom-game/$gameId'
import { Route as AuthenticatedSubscribedMainGameGeneratorGameGeneratorIdImport } from './routes/_authenticated/_subscribed/_main/game-generator/$gameGeneratorId'
import { Route as AuthenticatedSubscribedMainGameBuilderGameIdImport } from './routes/_authenticated/_subscribed/_main/game-builder/$gameId'

// Create/Update Routes

const TermsOfServiceRoute = TermsOfServiceImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyPolicyRoute = PrivacyPolicyImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRoute,
} as any)

const PaymentProcessorPolicyRoute = PaymentProcessorPolicyImport.update({
  id: '/payment-processor-policy',
  path: '/payment-processor-policy',
  getParentRoute: () => rootRoute,
} as any)

const LandingRouteRoute = LandingRouteImport.update({
  id: '/_landing',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRouteRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const LandingPaymentSuccessfulRoute = LandingPaymentSuccessfulImport.update({
  id: '/payment-successful',
  path: '/payment-successful',
  getParentRoute: () => LandingRouteRoute,
} as any)

const LandingPaymentFailedRoute = LandingPaymentFailedImport.update({
  id: '/payment-failed',
  path: '/payment-failed',
  getParentRoute: () => LandingRouteRoute,
} as any)

const AuthenticatedSubscribedRouteRoute =
  AuthenticatedSubscribedRouteImport.update({
    id: '/_subscribed',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const LandingPricingIndexRoute = LandingPricingIndexImport.update({
  id: '/pricing/',
  path: '/pricing/',
  getParentRoute: () => LandingRouteRoute,
} as any)

const LandingIndexIndexRoute = LandingIndexIndexImport.update({
  id: '/_index/',
  path: '/',
  getParentRoute: () => LandingRouteRoute,
} as any)

const AuthenticatedPatreonIndexRoute = AuthenticatedPatreonIndexImport.update({
  id: '/patreon/',
  path: '/patreon/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedSubscribedHudRoute = AuthenticatedSubscribedHudImport.update(
  {
    id: '/hud',
    path: '/hud',
    getParentRoute: () => AuthenticatedSubscribedRouteRoute,
  } as any,
)

const AuthenticatedSubscribedAdminRoute =
  AuthenticatedSubscribedAdminImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => AuthenticatedSubscribedRouteRoute,
  } as any)

const AuthenticateSignUpSplatRoute = AuthenticateSignUpSplatImport.update({
  id: '/_authenticate/sign-up/$',
  path: '/sign-up/$',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticateSignInSplatRoute = AuthenticateSignInSplatImport.update({
  id: '/_authenticate/sign-in/$',
  path: '/sign-in/$',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedSubscribedPlayRouteRoute =
  AuthenticatedSubscribedPlayRouteImport.update({
    id: '/play',
    path: '/play',
    getParentRoute: () => AuthenticatedSubscribedRouteRoute,
  } as any)

const AuthenticatedSubscribedMainRouteRoute =
  AuthenticatedSubscribedMainRouteImport.update({
    id: '/_main',
    getParentRoute: () => AuthenticatedSubscribedRouteRoute,
  } as any)

const AuthenticatedPatreonSignupIndexRoute =
  AuthenticatedPatreonSignupIndexImport.update({
    id: '/patreon/signup/',
    path: '/patreon/signup/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedSubscribedMainSettingsRoute =
  AuthenticatedSubscribedMainSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

const AuthenticatedSubscribedMainMyGamesRoute =
  AuthenticatedSubscribedMainMyGamesImport.update({
    id: '/my-games',
    path: '/my-games',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

const AuthenticatedSubscribedMainMyGameGeneratorsRoute =
  AuthenticatedSubscribedMainMyGameGeneratorsImport.update({
    id: '/my-game-generators',
    path: '/my-game-generators',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

const AuthenticatedSubscribedMainMetronomeRoute =
  AuthenticatedSubscribedMainMetronomeImport.update({
    id: '/metronome',
    path: '/metronome',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

const AuthenticatedSubscribedMainExploreScriptsRoute =
  AuthenticatedSubscribedMainExploreScriptsImport.update({
    id: '/explore-scripts',
    path: '/explore-scripts',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

const AuthenticatedSubscribedMainExploreGamesRoute =
  AuthenticatedSubscribedMainExploreGamesImport.update({
    id: '/explore-games',
    path: '/explore-games',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

const AuthenticatedSubscribedMainExploreGameGeneratorsRoute =
  AuthenticatedSubscribedMainExploreGameGeneratorsImport.update({
    id: '/explore-game-generators',
    path: '/explore-game-generators',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

const AuthenticatedSubscribedScriptScriptIdRouteRoute =
  AuthenticatedSubscribedScriptScriptIdRouteImport.update({
    id: '/script/$scriptId',
    path: '/script/$scriptId',
    getParentRoute: () => AuthenticatedSubscribedRouteRoute,
  } as any)

const AuthenticatedSubscribedMainGameGeneratorRouteRoute =
  AuthenticatedSubscribedMainGameGeneratorRouteImport.update({
    id: '/game-generator',
    path: '/game-generator',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

const AuthenticatedSubscribedScriptScriptIdIndexRoute =
  AuthenticatedSubscribedScriptScriptIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSubscribedScriptScriptIdRouteRoute,
  } as any)

const AuthenticatedSubscribedPlayGameGeneratorIndexRoute =
  AuthenticatedSubscribedPlayGameGeneratorIndexImport.update({
    id: '/game-generator/',
    path: '/game-generator/',
    getParentRoute: () => AuthenticatedSubscribedPlayRouteRoute,
  } as any)

const AuthenticatedSubscribedMainSubscriptionIndexRoute =
  AuthenticatedSubscribedMainSubscriptionIndexImport.update({
    id: '/subscription/',
    path: '/subscription/',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

const AuthenticatedSubscribedMainMyScriptsIndexRoute =
  AuthenticatedSubscribedMainMyScriptsIndexImport.update({
    id: '/my-scripts/',
    path: '/my-scripts/',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

const AuthenticatedSubscribedMainHomeIndexRoute =
  AuthenticatedSubscribedMainHomeIndexImport.update({
    id: '/home/',
    path: '/home/',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

const AuthenticatedSubscribedMainGameGeneratorIndexRoute =
  AuthenticatedSubscribedMainGameGeneratorIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSubscribedMainGameGeneratorRouteRoute,
  } as any)

const AuthenticatedSubscribedMainGameBuilderIndexRoute =
  AuthenticatedSubscribedMainGameBuilderIndexImport.update({
    id: '/game-builder/',
    path: '/game-builder/',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

const AuthenticatedSubscribedScriptScriptIdDialogRoute =
  AuthenticatedSubscribedScriptScriptIdDialogImport.update({
    id: '/dialog',
    path: '/dialog',
    getParentRoute: () => AuthenticatedSubscribedScriptScriptIdRouteRoute,
  } as any)

const AuthenticatedSubscribedPlayGameGeneratorGameGeneratorIdRoute =
  AuthenticatedSubscribedPlayGameGeneratorGameGeneratorIdImport.update({
    id: '/game-generator/$gameGeneratorId',
    path: '/game-generator/$gameGeneratorId',
    getParentRoute: () => AuthenticatedSubscribedPlayRouteRoute,
  } as any)

const AuthenticatedSubscribedPlayCustomGameGameIdRoute =
  AuthenticatedSubscribedPlayCustomGameGameIdImport.update({
    id: '/custom-game/$gameId',
    path: '/custom-game/$gameId',
    getParentRoute: () => AuthenticatedSubscribedPlayRouteRoute,
  } as any)

const AuthenticatedSubscribedMainGameGeneratorGameGeneratorIdRoute =
  AuthenticatedSubscribedMainGameGeneratorGameGeneratorIdImport.update({
    id: '/$gameGeneratorId',
    path: '/$gameGeneratorId',
    getParentRoute: () => AuthenticatedSubscribedMainGameGeneratorRouteRoute,
  } as any)

const AuthenticatedSubscribedMainGameBuilderGameIdRoute =
  AuthenticatedSubscribedMainGameBuilderGameIdImport.update({
    id: '/game-builder/$gameId',
    path: '/game-builder/$gameId',
    getParentRoute: () => AuthenticatedSubscribedMainRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/_landing': {
      id: '/_landing'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LandingRouteImport
      parentRoute: typeof rootRoute
    }
    '/payment-processor-policy': {
      id: '/payment-processor-policy'
      path: '/payment-processor-policy'
      fullPath: '/payment-processor-policy'
      preLoaderRoute: typeof PaymentProcessorPolicyImport
      parentRoute: typeof rootRoute
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyImport
      parentRoute: typeof rootRoute
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/_subscribed': {
      id: '/_authenticated/_subscribed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedSubscribedRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_landing/payment-failed': {
      id: '/_landing/payment-failed'
      path: '/payment-failed'
      fullPath: '/payment-failed'
      preLoaderRoute: typeof LandingPaymentFailedImport
      parentRoute: typeof LandingRouteImport
    }
    '/_landing/payment-successful': {
      id: '/_landing/payment-successful'
      path: '/payment-successful'
      fullPath: '/payment-successful'
      preLoaderRoute: typeof LandingPaymentSuccessfulImport
      parentRoute: typeof LandingRouteImport
    }
    '/_authenticated/_subscribed/_main': {
      id: '/_authenticated/_subscribed/_main'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedSubscribedMainRouteImport
      parentRoute: typeof AuthenticatedSubscribedRouteImport
    }
    '/_authenticated/_subscribed/play': {
      id: '/_authenticated/_subscribed/play'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof AuthenticatedSubscribedPlayRouteImport
      parentRoute: typeof AuthenticatedSubscribedRouteImport
    }
    '/_authenticate/sign-in/$': {
      id: '/_authenticate/sign-in/$'
      path: '/sign-in/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof AuthenticateSignInSplatImport
      parentRoute: typeof rootRoute
    }
    '/_authenticate/sign-up/$': {
      id: '/_authenticate/sign-up/$'
      path: '/sign-up/$'
      fullPath: '/sign-up/$'
      preLoaderRoute: typeof AuthenticateSignUpSplatImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/_subscribed/admin': {
      id: '/_authenticated/_subscribed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedSubscribedAdminImport
      parentRoute: typeof AuthenticatedSubscribedRouteImport
    }
    '/_authenticated/_subscribed/hud': {
      id: '/_authenticated/_subscribed/hud'
      path: '/hud'
      fullPath: '/hud'
      preLoaderRoute: typeof AuthenticatedSubscribedHudImport
      parentRoute: typeof AuthenticatedSubscribedRouteImport
    }
    '/_authenticated/patreon/': {
      id: '/_authenticated/patreon/'
      path: '/patreon'
      fullPath: '/patreon'
      preLoaderRoute: typeof AuthenticatedPatreonIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_landing/_index/': {
      id: '/_landing/_index/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LandingIndexIndexImport
      parentRoute: typeof LandingRouteImport
    }
    '/_landing/pricing/': {
      id: '/_landing/pricing/'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof LandingPricingIndexImport
      parentRoute: typeof LandingRouteImport
    }
    '/_authenticated/_subscribed/_main/game-generator': {
      id: '/_authenticated/_subscribed/_main/game-generator'
      path: '/game-generator'
      fullPath: '/game-generator'
      preLoaderRoute: typeof AuthenticatedSubscribedMainGameGeneratorRouteImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/_subscribed/script/$scriptId': {
      id: '/_authenticated/_subscribed/script/$scriptId'
      path: '/script/$scriptId'
      fullPath: '/script/$scriptId'
      preLoaderRoute: typeof AuthenticatedSubscribedScriptScriptIdRouteImport
      parentRoute: typeof AuthenticatedSubscribedRouteImport
    }
    '/_authenticated/_subscribed/_main/explore-game-generators': {
      id: '/_authenticated/_subscribed/_main/explore-game-generators'
      path: '/explore-game-generators'
      fullPath: '/explore-game-generators'
      preLoaderRoute: typeof AuthenticatedSubscribedMainExploreGameGeneratorsImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/_subscribed/_main/explore-games': {
      id: '/_authenticated/_subscribed/_main/explore-games'
      path: '/explore-games'
      fullPath: '/explore-games'
      preLoaderRoute: typeof AuthenticatedSubscribedMainExploreGamesImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/_subscribed/_main/explore-scripts': {
      id: '/_authenticated/_subscribed/_main/explore-scripts'
      path: '/explore-scripts'
      fullPath: '/explore-scripts'
      preLoaderRoute: typeof AuthenticatedSubscribedMainExploreScriptsImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/_subscribed/_main/metronome': {
      id: '/_authenticated/_subscribed/_main/metronome'
      path: '/metronome'
      fullPath: '/metronome'
      preLoaderRoute: typeof AuthenticatedSubscribedMainMetronomeImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/_subscribed/_main/my-game-generators': {
      id: '/_authenticated/_subscribed/_main/my-game-generators'
      path: '/my-game-generators'
      fullPath: '/my-game-generators'
      preLoaderRoute: typeof AuthenticatedSubscribedMainMyGameGeneratorsImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/_subscribed/_main/my-games': {
      id: '/_authenticated/_subscribed/_main/my-games'
      path: '/my-games'
      fullPath: '/my-games'
      preLoaderRoute: typeof AuthenticatedSubscribedMainMyGamesImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/_subscribed/_main/settings': {
      id: '/_authenticated/_subscribed/_main/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSubscribedMainSettingsImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/patreon/signup/': {
      id: '/_authenticated/patreon/signup/'
      path: '/patreon/signup'
      fullPath: '/patreon/signup'
      preLoaderRoute: typeof AuthenticatedPatreonSignupIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/_subscribed/_main/game-builder/$gameId': {
      id: '/_authenticated/_subscribed/_main/game-builder/$gameId'
      path: '/game-builder/$gameId'
      fullPath: '/game-builder/$gameId'
      preLoaderRoute: typeof AuthenticatedSubscribedMainGameBuilderGameIdImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/_subscribed/_main/game-generator/$gameGeneratorId': {
      id: '/_authenticated/_subscribed/_main/game-generator/$gameGeneratorId'
      path: '/$gameGeneratorId'
      fullPath: '/game-generator/$gameGeneratorId'
      preLoaderRoute: typeof AuthenticatedSubscribedMainGameGeneratorGameGeneratorIdImport
      parentRoute: typeof AuthenticatedSubscribedMainGameGeneratorRouteImport
    }
    '/_authenticated/_subscribed/play/custom-game/$gameId': {
      id: '/_authenticated/_subscribed/play/custom-game/$gameId'
      path: '/custom-game/$gameId'
      fullPath: '/play/custom-game/$gameId'
      preLoaderRoute: typeof AuthenticatedSubscribedPlayCustomGameGameIdImport
      parentRoute: typeof AuthenticatedSubscribedPlayRouteImport
    }
    '/_authenticated/_subscribed/play/game-generator/$gameGeneratorId': {
      id: '/_authenticated/_subscribed/play/game-generator/$gameGeneratorId'
      path: '/game-generator/$gameGeneratorId'
      fullPath: '/play/game-generator/$gameGeneratorId'
      preLoaderRoute: typeof AuthenticatedSubscribedPlayGameGeneratorGameGeneratorIdImport
      parentRoute: typeof AuthenticatedSubscribedPlayRouteImport
    }
    '/_authenticated/_subscribed/script/$scriptId/dialog': {
      id: '/_authenticated/_subscribed/script/$scriptId/dialog'
      path: '/dialog'
      fullPath: '/script/$scriptId/dialog'
      preLoaderRoute: typeof AuthenticatedSubscribedScriptScriptIdDialogImport
      parentRoute: typeof AuthenticatedSubscribedScriptScriptIdRouteImport
    }
    '/_authenticated/_subscribed/_main/game-builder/': {
      id: '/_authenticated/_subscribed/_main/game-builder/'
      path: '/game-builder'
      fullPath: '/game-builder'
      preLoaderRoute: typeof AuthenticatedSubscribedMainGameBuilderIndexImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/_subscribed/_main/game-generator/': {
      id: '/_authenticated/_subscribed/_main/game-generator/'
      path: '/'
      fullPath: '/game-generator/'
      preLoaderRoute: typeof AuthenticatedSubscribedMainGameGeneratorIndexImport
      parentRoute: typeof AuthenticatedSubscribedMainGameGeneratorRouteImport
    }
    '/_authenticated/_subscribed/_main/home/': {
      id: '/_authenticated/_subscribed/_main/home/'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedSubscribedMainHomeIndexImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/_subscribed/_main/my-scripts/': {
      id: '/_authenticated/_subscribed/_main/my-scripts/'
      path: '/my-scripts'
      fullPath: '/my-scripts'
      preLoaderRoute: typeof AuthenticatedSubscribedMainMyScriptsIndexImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/_subscribed/_main/subscription/': {
      id: '/_authenticated/_subscribed/_main/subscription/'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof AuthenticatedSubscribedMainSubscriptionIndexImport
      parentRoute: typeof AuthenticatedSubscribedMainRouteImport
    }
    '/_authenticated/_subscribed/play/game-generator/': {
      id: '/_authenticated/_subscribed/play/game-generator/'
      path: '/game-generator'
      fullPath: '/play/game-generator'
      preLoaderRoute: typeof AuthenticatedSubscribedPlayGameGeneratorIndexImport
      parentRoute: typeof AuthenticatedSubscribedPlayRouteImport
    }
    '/_authenticated/_subscribed/script/$scriptId/': {
      id: '/_authenticated/_subscribed/script/$scriptId/'
      path: '/'
      fullPath: '/script/$scriptId/'
      preLoaderRoute: typeof AuthenticatedSubscribedScriptScriptIdIndexImport
      parentRoute: typeof AuthenticatedSubscribedScriptScriptIdRouteImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedSubscribedMainGameGeneratorRouteRouteChildren {
  AuthenticatedSubscribedMainGameGeneratorGameGeneratorIdRoute: typeof AuthenticatedSubscribedMainGameGeneratorGameGeneratorIdRoute
  AuthenticatedSubscribedMainGameGeneratorIndexRoute: typeof AuthenticatedSubscribedMainGameGeneratorIndexRoute
}

const AuthenticatedSubscribedMainGameGeneratorRouteRouteChildren: AuthenticatedSubscribedMainGameGeneratorRouteRouteChildren =
  {
    AuthenticatedSubscribedMainGameGeneratorGameGeneratorIdRoute:
      AuthenticatedSubscribedMainGameGeneratorGameGeneratorIdRoute,
    AuthenticatedSubscribedMainGameGeneratorIndexRoute:
      AuthenticatedSubscribedMainGameGeneratorIndexRoute,
  }

const AuthenticatedSubscribedMainGameGeneratorRouteRouteWithChildren =
  AuthenticatedSubscribedMainGameGeneratorRouteRoute._addFileChildren(
    AuthenticatedSubscribedMainGameGeneratorRouteRouteChildren,
  )

interface AuthenticatedSubscribedMainRouteRouteChildren {
  AuthenticatedSubscribedMainGameGeneratorRouteRoute: typeof AuthenticatedSubscribedMainGameGeneratorRouteRouteWithChildren
  AuthenticatedSubscribedMainExploreGameGeneratorsRoute: typeof AuthenticatedSubscribedMainExploreGameGeneratorsRoute
  AuthenticatedSubscribedMainExploreGamesRoute: typeof AuthenticatedSubscribedMainExploreGamesRoute
  AuthenticatedSubscribedMainExploreScriptsRoute: typeof AuthenticatedSubscribedMainExploreScriptsRoute
  AuthenticatedSubscribedMainMetronomeRoute: typeof AuthenticatedSubscribedMainMetronomeRoute
  AuthenticatedSubscribedMainMyGameGeneratorsRoute: typeof AuthenticatedSubscribedMainMyGameGeneratorsRoute
  AuthenticatedSubscribedMainMyGamesRoute: typeof AuthenticatedSubscribedMainMyGamesRoute
  AuthenticatedSubscribedMainSettingsRoute: typeof AuthenticatedSubscribedMainSettingsRoute
  AuthenticatedSubscribedMainGameBuilderGameIdRoute: typeof AuthenticatedSubscribedMainGameBuilderGameIdRoute
  AuthenticatedSubscribedMainGameBuilderIndexRoute: typeof AuthenticatedSubscribedMainGameBuilderIndexRoute
  AuthenticatedSubscribedMainHomeIndexRoute: typeof AuthenticatedSubscribedMainHomeIndexRoute
  AuthenticatedSubscribedMainMyScriptsIndexRoute: typeof AuthenticatedSubscribedMainMyScriptsIndexRoute
  AuthenticatedSubscribedMainSubscriptionIndexRoute: typeof AuthenticatedSubscribedMainSubscriptionIndexRoute
}

const AuthenticatedSubscribedMainRouteRouteChildren: AuthenticatedSubscribedMainRouteRouteChildren =
  {
    AuthenticatedSubscribedMainGameGeneratorRouteRoute:
      AuthenticatedSubscribedMainGameGeneratorRouteRouteWithChildren,
    AuthenticatedSubscribedMainExploreGameGeneratorsRoute:
      AuthenticatedSubscribedMainExploreGameGeneratorsRoute,
    AuthenticatedSubscribedMainExploreGamesRoute:
      AuthenticatedSubscribedMainExploreGamesRoute,
    AuthenticatedSubscribedMainExploreScriptsRoute:
      AuthenticatedSubscribedMainExploreScriptsRoute,
    AuthenticatedSubscribedMainMetronomeRoute:
      AuthenticatedSubscribedMainMetronomeRoute,
    AuthenticatedSubscribedMainMyGameGeneratorsRoute:
      AuthenticatedSubscribedMainMyGameGeneratorsRoute,
    AuthenticatedSubscribedMainMyGamesRoute:
      AuthenticatedSubscribedMainMyGamesRoute,
    AuthenticatedSubscribedMainSettingsRoute:
      AuthenticatedSubscribedMainSettingsRoute,
    AuthenticatedSubscribedMainGameBuilderGameIdRoute:
      AuthenticatedSubscribedMainGameBuilderGameIdRoute,
    AuthenticatedSubscribedMainGameBuilderIndexRoute:
      AuthenticatedSubscribedMainGameBuilderIndexRoute,
    AuthenticatedSubscribedMainHomeIndexRoute:
      AuthenticatedSubscribedMainHomeIndexRoute,
    AuthenticatedSubscribedMainMyScriptsIndexRoute:
      AuthenticatedSubscribedMainMyScriptsIndexRoute,
    AuthenticatedSubscribedMainSubscriptionIndexRoute:
      AuthenticatedSubscribedMainSubscriptionIndexRoute,
  }

const AuthenticatedSubscribedMainRouteRouteWithChildren =
  AuthenticatedSubscribedMainRouteRoute._addFileChildren(
    AuthenticatedSubscribedMainRouteRouteChildren,
  )

interface AuthenticatedSubscribedPlayRouteRouteChildren {
  AuthenticatedSubscribedPlayCustomGameGameIdRoute: typeof AuthenticatedSubscribedPlayCustomGameGameIdRoute
  AuthenticatedSubscribedPlayGameGeneratorGameGeneratorIdRoute: typeof AuthenticatedSubscribedPlayGameGeneratorGameGeneratorIdRoute
  AuthenticatedSubscribedPlayGameGeneratorIndexRoute: typeof AuthenticatedSubscribedPlayGameGeneratorIndexRoute
}

const AuthenticatedSubscribedPlayRouteRouteChildren: AuthenticatedSubscribedPlayRouteRouteChildren =
  {
    AuthenticatedSubscribedPlayCustomGameGameIdRoute:
      AuthenticatedSubscribedPlayCustomGameGameIdRoute,
    AuthenticatedSubscribedPlayGameGeneratorGameGeneratorIdRoute:
      AuthenticatedSubscribedPlayGameGeneratorGameGeneratorIdRoute,
    AuthenticatedSubscribedPlayGameGeneratorIndexRoute:
      AuthenticatedSubscribedPlayGameGeneratorIndexRoute,
  }

const AuthenticatedSubscribedPlayRouteRouteWithChildren =
  AuthenticatedSubscribedPlayRouteRoute._addFileChildren(
    AuthenticatedSubscribedPlayRouteRouteChildren,
  )

interface AuthenticatedSubscribedScriptScriptIdRouteRouteChildren {
  AuthenticatedSubscribedScriptScriptIdDialogRoute: typeof AuthenticatedSubscribedScriptScriptIdDialogRoute
  AuthenticatedSubscribedScriptScriptIdIndexRoute: typeof AuthenticatedSubscribedScriptScriptIdIndexRoute
}

const AuthenticatedSubscribedScriptScriptIdRouteRouteChildren: AuthenticatedSubscribedScriptScriptIdRouteRouteChildren =
  {
    AuthenticatedSubscribedScriptScriptIdDialogRoute:
      AuthenticatedSubscribedScriptScriptIdDialogRoute,
    AuthenticatedSubscribedScriptScriptIdIndexRoute:
      AuthenticatedSubscribedScriptScriptIdIndexRoute,
  }

const AuthenticatedSubscribedScriptScriptIdRouteRouteWithChildren =
  AuthenticatedSubscribedScriptScriptIdRouteRoute._addFileChildren(
    AuthenticatedSubscribedScriptScriptIdRouteRouteChildren,
  )

interface AuthenticatedSubscribedRouteRouteChildren {
  AuthenticatedSubscribedMainRouteRoute: typeof AuthenticatedSubscribedMainRouteRouteWithChildren
  AuthenticatedSubscribedPlayRouteRoute: typeof AuthenticatedSubscribedPlayRouteRouteWithChildren
  AuthenticatedSubscribedAdminRoute: typeof AuthenticatedSubscribedAdminRoute
  AuthenticatedSubscribedHudRoute: typeof AuthenticatedSubscribedHudRoute
  AuthenticatedSubscribedScriptScriptIdRouteRoute: typeof AuthenticatedSubscribedScriptScriptIdRouteRouteWithChildren
}

const AuthenticatedSubscribedRouteRouteChildren: AuthenticatedSubscribedRouteRouteChildren =
  {
    AuthenticatedSubscribedMainRouteRoute:
      AuthenticatedSubscribedMainRouteRouteWithChildren,
    AuthenticatedSubscribedPlayRouteRoute:
      AuthenticatedSubscribedPlayRouteRouteWithChildren,
    AuthenticatedSubscribedAdminRoute: AuthenticatedSubscribedAdminRoute,
    AuthenticatedSubscribedHudRoute: AuthenticatedSubscribedHudRoute,
    AuthenticatedSubscribedScriptScriptIdRouteRoute:
      AuthenticatedSubscribedScriptScriptIdRouteRouteWithChildren,
  }

const AuthenticatedSubscribedRouteRouteWithChildren =
  AuthenticatedSubscribedRouteRoute._addFileChildren(
    AuthenticatedSubscribedRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSubscribedRouteRoute: typeof AuthenticatedSubscribedRouteRouteWithChildren
  AuthenticatedPatreonIndexRoute: typeof AuthenticatedPatreonIndexRoute
  AuthenticatedPatreonSignupIndexRoute: typeof AuthenticatedPatreonSignupIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSubscribedRouteRoute:
    AuthenticatedSubscribedRouteRouteWithChildren,
  AuthenticatedPatreonIndexRoute: AuthenticatedPatreonIndexRoute,
  AuthenticatedPatreonSignupIndexRoute: AuthenticatedPatreonSignupIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface LandingRouteRouteChildren {
  LandingPaymentFailedRoute: typeof LandingPaymentFailedRoute
  LandingPaymentSuccessfulRoute: typeof LandingPaymentSuccessfulRoute
  LandingIndexIndexRoute: typeof LandingIndexIndexRoute
  LandingPricingIndexRoute: typeof LandingPricingIndexRoute
}

const LandingRouteRouteChildren: LandingRouteRouteChildren = {
  LandingPaymentFailedRoute: LandingPaymentFailedRoute,
  LandingPaymentSuccessfulRoute: LandingPaymentSuccessfulRoute,
  LandingIndexIndexRoute: LandingIndexIndexRoute,
  LandingPricingIndexRoute: LandingPricingIndexRoute,
}

const LandingRouteRouteWithChildren = LandingRouteRoute._addFileChildren(
  LandingRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedSubscribedMainRouteRouteWithChildren
  '/payment-processor-policy': typeof PaymentProcessorPolicyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/payment-failed': typeof LandingPaymentFailedRoute
  '/payment-successful': typeof LandingPaymentSuccessfulRoute
  '/play': typeof AuthenticatedSubscribedPlayRouteRouteWithChildren
  '/sign-in/$': typeof AuthenticateSignInSplatRoute
  '/sign-up/$': typeof AuthenticateSignUpSplatRoute
  '/admin': typeof AuthenticatedSubscribedAdminRoute
  '/hud': typeof AuthenticatedSubscribedHudRoute
  '/patreon': typeof AuthenticatedPatreonIndexRoute
  '/': typeof LandingIndexIndexRoute
  '/pricing': typeof LandingPricingIndexRoute
  '/game-generator': typeof AuthenticatedSubscribedMainGameGeneratorRouteRouteWithChildren
  '/script/$scriptId': typeof AuthenticatedSubscribedScriptScriptIdRouteRouteWithChildren
  '/explore-game-generators': typeof AuthenticatedSubscribedMainExploreGameGeneratorsRoute
  '/explore-games': typeof AuthenticatedSubscribedMainExploreGamesRoute
  '/explore-scripts': typeof AuthenticatedSubscribedMainExploreScriptsRoute
  '/metronome': typeof AuthenticatedSubscribedMainMetronomeRoute
  '/my-game-generators': typeof AuthenticatedSubscribedMainMyGameGeneratorsRoute
  '/my-games': typeof AuthenticatedSubscribedMainMyGamesRoute
  '/settings': typeof AuthenticatedSubscribedMainSettingsRoute
  '/patreon/signup': typeof AuthenticatedPatreonSignupIndexRoute
  '/game-builder/$gameId': typeof AuthenticatedSubscribedMainGameBuilderGameIdRoute
  '/game-generator/$gameGeneratorId': typeof AuthenticatedSubscribedMainGameGeneratorGameGeneratorIdRoute
  '/play/custom-game/$gameId': typeof AuthenticatedSubscribedPlayCustomGameGameIdRoute
  '/play/game-generator/$gameGeneratorId': typeof AuthenticatedSubscribedPlayGameGeneratorGameGeneratorIdRoute
  '/script/$scriptId/dialog': typeof AuthenticatedSubscribedScriptScriptIdDialogRoute
  '/game-builder': typeof AuthenticatedSubscribedMainGameBuilderIndexRoute
  '/game-generator/': typeof AuthenticatedSubscribedMainGameGeneratorIndexRoute
  '/home': typeof AuthenticatedSubscribedMainHomeIndexRoute
  '/my-scripts': typeof AuthenticatedSubscribedMainMyScriptsIndexRoute
  '/subscription': typeof AuthenticatedSubscribedMainSubscriptionIndexRoute
  '/play/game-generator': typeof AuthenticatedSubscribedPlayGameGeneratorIndexRoute
  '/script/$scriptId/': typeof AuthenticatedSubscribedScriptScriptIdIndexRoute
}

export interface FileRoutesByTo {
  '': typeof AuthenticatedSubscribedMainRouteRouteWithChildren
  '/payment-processor-policy': typeof PaymentProcessorPolicyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/payment-failed': typeof LandingPaymentFailedRoute
  '/payment-successful': typeof LandingPaymentSuccessfulRoute
  '/play': typeof AuthenticatedSubscribedPlayRouteRouteWithChildren
  '/sign-in/$': typeof AuthenticateSignInSplatRoute
  '/sign-up/$': typeof AuthenticateSignUpSplatRoute
  '/admin': typeof AuthenticatedSubscribedAdminRoute
  '/hud': typeof AuthenticatedSubscribedHudRoute
  '/patreon': typeof AuthenticatedPatreonIndexRoute
  '/': typeof LandingIndexIndexRoute
  '/pricing': typeof LandingPricingIndexRoute
  '/explore-game-generators': typeof AuthenticatedSubscribedMainExploreGameGeneratorsRoute
  '/explore-games': typeof AuthenticatedSubscribedMainExploreGamesRoute
  '/explore-scripts': typeof AuthenticatedSubscribedMainExploreScriptsRoute
  '/metronome': typeof AuthenticatedSubscribedMainMetronomeRoute
  '/my-game-generators': typeof AuthenticatedSubscribedMainMyGameGeneratorsRoute
  '/my-games': typeof AuthenticatedSubscribedMainMyGamesRoute
  '/settings': typeof AuthenticatedSubscribedMainSettingsRoute
  '/patreon/signup': typeof AuthenticatedPatreonSignupIndexRoute
  '/game-builder/$gameId': typeof AuthenticatedSubscribedMainGameBuilderGameIdRoute
  '/game-generator/$gameGeneratorId': typeof AuthenticatedSubscribedMainGameGeneratorGameGeneratorIdRoute
  '/play/custom-game/$gameId': typeof AuthenticatedSubscribedPlayCustomGameGameIdRoute
  '/play/game-generator/$gameGeneratorId': typeof AuthenticatedSubscribedPlayGameGeneratorGameGeneratorIdRoute
  '/script/$scriptId/dialog': typeof AuthenticatedSubscribedScriptScriptIdDialogRoute
  '/game-builder': typeof AuthenticatedSubscribedMainGameBuilderIndexRoute
  '/game-generator': typeof AuthenticatedSubscribedMainGameGeneratorIndexRoute
  '/home': typeof AuthenticatedSubscribedMainHomeIndexRoute
  '/my-scripts': typeof AuthenticatedSubscribedMainMyScriptsIndexRoute
  '/subscription': typeof AuthenticatedSubscribedMainSubscriptionIndexRoute
  '/play/game-generator': typeof AuthenticatedSubscribedPlayGameGeneratorIndexRoute
  '/script/$scriptId': typeof AuthenticatedSubscribedScriptScriptIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_landing': typeof LandingRouteRouteWithChildren
  '/payment-processor-policy': typeof PaymentProcessorPolicyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/_authenticated/_subscribed': typeof AuthenticatedSubscribedRouteRouteWithChildren
  '/_landing/payment-failed': typeof LandingPaymentFailedRoute
  '/_landing/payment-successful': typeof LandingPaymentSuccessfulRoute
  '/_authenticated/_subscribed/_main': typeof AuthenticatedSubscribedMainRouteRouteWithChildren
  '/_authenticated/_subscribed/play': typeof AuthenticatedSubscribedPlayRouteRouteWithChildren
  '/_authenticate/sign-in/$': typeof AuthenticateSignInSplatRoute
  '/_authenticate/sign-up/$': typeof AuthenticateSignUpSplatRoute
  '/_authenticated/_subscribed/admin': typeof AuthenticatedSubscribedAdminRoute
  '/_authenticated/_subscribed/hud': typeof AuthenticatedSubscribedHudRoute
  '/_authenticated/patreon/': typeof AuthenticatedPatreonIndexRoute
  '/_landing/_index/': typeof LandingIndexIndexRoute
  '/_landing/pricing/': typeof LandingPricingIndexRoute
  '/_authenticated/_subscribed/_main/game-generator': typeof AuthenticatedSubscribedMainGameGeneratorRouteRouteWithChildren
  '/_authenticated/_subscribed/script/$scriptId': typeof AuthenticatedSubscribedScriptScriptIdRouteRouteWithChildren
  '/_authenticated/_subscribed/_main/explore-game-generators': typeof AuthenticatedSubscribedMainExploreGameGeneratorsRoute
  '/_authenticated/_subscribed/_main/explore-games': typeof AuthenticatedSubscribedMainExploreGamesRoute
  '/_authenticated/_subscribed/_main/explore-scripts': typeof AuthenticatedSubscribedMainExploreScriptsRoute
  '/_authenticated/_subscribed/_main/metronome': typeof AuthenticatedSubscribedMainMetronomeRoute
  '/_authenticated/_subscribed/_main/my-game-generators': typeof AuthenticatedSubscribedMainMyGameGeneratorsRoute
  '/_authenticated/_subscribed/_main/my-games': typeof AuthenticatedSubscribedMainMyGamesRoute
  '/_authenticated/_subscribed/_main/settings': typeof AuthenticatedSubscribedMainSettingsRoute
  '/_authenticated/patreon/signup/': typeof AuthenticatedPatreonSignupIndexRoute
  '/_authenticated/_subscribed/_main/game-builder/$gameId': typeof AuthenticatedSubscribedMainGameBuilderGameIdRoute
  '/_authenticated/_subscribed/_main/game-generator/$gameGeneratorId': typeof AuthenticatedSubscribedMainGameGeneratorGameGeneratorIdRoute
  '/_authenticated/_subscribed/play/custom-game/$gameId': typeof AuthenticatedSubscribedPlayCustomGameGameIdRoute
  '/_authenticated/_subscribed/play/game-generator/$gameGeneratorId': typeof AuthenticatedSubscribedPlayGameGeneratorGameGeneratorIdRoute
  '/_authenticated/_subscribed/script/$scriptId/dialog': typeof AuthenticatedSubscribedScriptScriptIdDialogRoute
  '/_authenticated/_subscribed/_main/game-builder/': typeof AuthenticatedSubscribedMainGameBuilderIndexRoute
  '/_authenticated/_subscribed/_main/game-generator/': typeof AuthenticatedSubscribedMainGameGeneratorIndexRoute
  '/_authenticated/_subscribed/_main/home/': typeof AuthenticatedSubscribedMainHomeIndexRoute
  '/_authenticated/_subscribed/_main/my-scripts/': typeof AuthenticatedSubscribedMainMyScriptsIndexRoute
  '/_authenticated/_subscribed/_main/subscription/': typeof AuthenticatedSubscribedMainSubscriptionIndexRoute
  '/_authenticated/_subscribed/play/game-generator/': typeof AuthenticatedSubscribedPlayGameGeneratorIndexRoute
  '/_authenticated/_subscribed/script/$scriptId/': typeof AuthenticatedSubscribedScriptScriptIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/payment-processor-policy'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/payment-failed'
    | '/payment-successful'
    | '/play'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/admin'
    | '/hud'
    | '/patreon'
    | '/'
    | '/pricing'
    | '/game-generator'
    | '/script/$scriptId'
    | '/explore-game-generators'
    | '/explore-games'
    | '/explore-scripts'
    | '/metronome'
    | '/my-game-generators'
    | '/my-games'
    | '/settings'
    | '/patreon/signup'
    | '/game-builder/$gameId'
    | '/game-generator/$gameGeneratorId'
    | '/play/custom-game/$gameId'
    | '/play/game-generator/$gameGeneratorId'
    | '/script/$scriptId/dialog'
    | '/game-builder'
    | '/game-generator/'
    | '/home'
    | '/my-scripts'
    | '/subscription'
    | '/play/game-generator'
    | '/script/$scriptId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/payment-processor-policy'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/payment-failed'
    | '/payment-successful'
    | '/play'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/admin'
    | '/hud'
    | '/patreon'
    | '/'
    | '/pricing'
    | '/explore-game-generators'
    | '/explore-games'
    | '/explore-scripts'
    | '/metronome'
    | '/my-game-generators'
    | '/my-games'
    | '/settings'
    | '/patreon/signup'
    | '/game-builder/$gameId'
    | '/game-generator/$gameGeneratorId'
    | '/play/custom-game/$gameId'
    | '/play/game-generator/$gameGeneratorId'
    | '/script/$scriptId/dialog'
    | '/game-builder'
    | '/game-generator'
    | '/home'
    | '/my-scripts'
    | '/subscription'
    | '/play/game-generator'
    | '/script/$scriptId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_landing'
    | '/payment-processor-policy'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/_authenticated/_subscribed'
    | '/_landing/payment-failed'
    | '/_landing/payment-successful'
    | '/_authenticated/_subscribed/_main'
    | '/_authenticated/_subscribed/play'
    | '/_authenticate/sign-in/$'
    | '/_authenticate/sign-up/$'
    | '/_authenticated/_subscribed/admin'
    | '/_authenticated/_subscribed/hud'
    | '/_authenticated/patreon/'
    | '/_landing/_index/'
    | '/_landing/pricing/'
    | '/_authenticated/_subscribed/_main/game-generator'
    | '/_authenticated/_subscribed/script/$scriptId'
    | '/_authenticated/_subscribed/_main/explore-game-generators'
    | '/_authenticated/_subscribed/_main/explore-games'
    | '/_authenticated/_subscribed/_main/explore-scripts'
    | '/_authenticated/_subscribed/_main/metronome'
    | '/_authenticated/_subscribed/_main/my-game-generators'
    | '/_authenticated/_subscribed/_main/my-games'
    | '/_authenticated/_subscribed/_main/settings'
    | '/_authenticated/patreon/signup/'
    | '/_authenticated/_subscribed/_main/game-builder/$gameId'
    | '/_authenticated/_subscribed/_main/game-generator/$gameGeneratorId'
    | '/_authenticated/_subscribed/play/custom-game/$gameId'
    | '/_authenticated/_subscribed/play/game-generator/$gameGeneratorId'
    | '/_authenticated/_subscribed/script/$scriptId/dialog'
    | '/_authenticated/_subscribed/_main/game-builder/'
    | '/_authenticated/_subscribed/_main/game-generator/'
    | '/_authenticated/_subscribed/_main/home/'
    | '/_authenticated/_subscribed/_main/my-scripts/'
    | '/_authenticated/_subscribed/_main/subscription/'
    | '/_authenticated/_subscribed/play/game-generator/'
    | '/_authenticated/_subscribed/script/$scriptId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LandingRouteRoute: typeof LandingRouteRouteWithChildren
  PaymentProcessorPolicyRoute: typeof PaymentProcessorPolicyRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  AuthenticateSignInSplatRoute: typeof AuthenticateSignInSplatRoute
  AuthenticateSignUpSplatRoute: typeof AuthenticateSignUpSplatRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LandingRouteRoute: LandingRouteRouteWithChildren,
  PaymentProcessorPolicyRoute: PaymentProcessorPolicyRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  AuthenticateSignInSplatRoute: AuthenticateSignInSplatRoute,
  AuthenticateSignUpSplatRoute: AuthenticateSignUpSplatRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/_landing",
        "/payment-processor-policy",
        "/privacy-policy",
        "/terms-of-service",
        "/_authenticate/sign-in/$",
        "/_authenticate/sign-up/$"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated/route.tsx",
      "children": [
        "/_authenticated/_subscribed",
        "/_authenticated/patreon/",
        "/_authenticated/patreon/signup/"
      ]
    },
    "/_landing": {
      "filePath": "_landing/route.tsx",
      "children": [
        "/_landing/payment-failed",
        "/_landing/payment-successful",
        "/_landing/_index/",
        "/_landing/pricing/"
      ]
    },
    "/payment-processor-policy": {
      "filePath": "payment-processor-policy.tsx"
    },
    "/privacy-policy": {
      "filePath": "privacy-policy.tsx"
    },
    "/terms-of-service": {
      "filePath": "terms-of-service.tsx"
    },
    "/_authenticated/_subscribed": {
      "filePath": "_authenticated/_subscribed/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_subscribed/_main",
        "/_authenticated/_subscribed/play",
        "/_authenticated/_subscribed/admin",
        "/_authenticated/_subscribed/hud",
        "/_authenticated/_subscribed/script/$scriptId"
      ]
    },
    "/_landing/payment-failed": {
      "filePath": "_landing/payment-failed.tsx",
      "parent": "/_landing"
    },
    "/_landing/payment-successful": {
      "filePath": "_landing/payment-successful.tsx",
      "parent": "/_landing"
    },
    "/_authenticated/_subscribed/_main": {
      "filePath": "_authenticated/_subscribed/_main/route.tsx",
      "parent": "/_authenticated/_subscribed",
      "children": [
        "/_authenticated/_subscribed/_main/game-generator",
        "/_authenticated/_subscribed/_main/explore-game-generators",
        "/_authenticated/_subscribed/_main/explore-games",
        "/_authenticated/_subscribed/_main/explore-scripts",
        "/_authenticated/_subscribed/_main/metronome",
        "/_authenticated/_subscribed/_main/my-game-generators",
        "/_authenticated/_subscribed/_main/my-games",
        "/_authenticated/_subscribed/_main/settings",
        "/_authenticated/_subscribed/_main/game-builder/$gameId",
        "/_authenticated/_subscribed/_main/game-builder/",
        "/_authenticated/_subscribed/_main/home/",
        "/_authenticated/_subscribed/_main/my-scripts/",
        "/_authenticated/_subscribed/_main/subscription/"
      ]
    },
    "/_authenticated/_subscribed/play": {
      "filePath": "_authenticated/_subscribed/play/route.tsx",
      "parent": "/_authenticated/_subscribed",
      "children": [
        "/_authenticated/_subscribed/play/custom-game/$gameId",
        "/_authenticated/_subscribed/play/game-generator/$gameGeneratorId",
        "/_authenticated/_subscribed/play/game-generator/"
      ]
    },
    "/_authenticate/sign-in/$": {
      "filePath": "_authenticate/sign-in.$.tsx"
    },
    "/_authenticate/sign-up/$": {
      "filePath": "_authenticate/sign-up.$.tsx"
    },
    "/_authenticated/_subscribed/admin": {
      "filePath": "_authenticated/_subscribed/admin.tsx",
      "parent": "/_authenticated/_subscribed"
    },
    "/_authenticated/_subscribed/hud": {
      "filePath": "_authenticated/_subscribed/hud.tsx",
      "parent": "/_authenticated/_subscribed"
    },
    "/_authenticated/patreon/": {
      "filePath": "_authenticated/patreon/index.tsx",
      "parent": "/_authenticated"
    },
    "/_landing/_index/": {
      "filePath": "_landing/_index/index.tsx",
      "parent": "/_landing"
    },
    "/_landing/pricing/": {
      "filePath": "_landing/pricing/index.tsx",
      "parent": "/_landing"
    },
    "/_authenticated/_subscribed/_main/game-generator": {
      "filePath": "_authenticated/_subscribed/_main/game-generator/route.tsx",
      "parent": "/_authenticated/_subscribed/_main",
      "children": [
        "/_authenticated/_subscribed/_main/game-generator/$gameGeneratorId",
        "/_authenticated/_subscribed/_main/game-generator/"
      ]
    },
    "/_authenticated/_subscribed/script/$scriptId": {
      "filePath": "_authenticated/_subscribed/script.$scriptId/route.tsx",
      "parent": "/_authenticated/_subscribed",
      "children": [
        "/_authenticated/_subscribed/script/$scriptId/dialog",
        "/_authenticated/_subscribed/script/$scriptId/"
      ]
    },
    "/_authenticated/_subscribed/_main/explore-game-generators": {
      "filePath": "_authenticated/_subscribed/_main/explore-game-generators.tsx",
      "parent": "/_authenticated/_subscribed/_main"
    },
    "/_authenticated/_subscribed/_main/explore-games": {
      "filePath": "_authenticated/_subscribed/_main/explore-games.tsx",
      "parent": "/_authenticated/_subscribed/_main"
    },
    "/_authenticated/_subscribed/_main/explore-scripts": {
      "filePath": "_authenticated/_subscribed/_main/explore-scripts.tsx",
      "parent": "/_authenticated/_subscribed/_main"
    },
    "/_authenticated/_subscribed/_main/metronome": {
      "filePath": "_authenticated/_subscribed/_main/metronome.tsx",
      "parent": "/_authenticated/_subscribed/_main"
    },
    "/_authenticated/_subscribed/_main/my-game-generators": {
      "filePath": "_authenticated/_subscribed/_main/my-game-generators.tsx",
      "parent": "/_authenticated/_subscribed/_main"
    },
    "/_authenticated/_subscribed/_main/my-games": {
      "filePath": "_authenticated/_subscribed/_main/my-games.tsx",
      "parent": "/_authenticated/_subscribed/_main"
    },
    "/_authenticated/_subscribed/_main/settings": {
      "filePath": "_authenticated/_subscribed/_main/settings.tsx",
      "parent": "/_authenticated/_subscribed/_main"
    },
    "/_authenticated/patreon/signup/": {
      "filePath": "_authenticated/patreon/signup/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/_subscribed/_main/game-builder/$gameId": {
      "filePath": "_authenticated/_subscribed/_main/game-builder/$gameId.tsx",
      "parent": "/_authenticated/_subscribed/_main"
    },
    "/_authenticated/_subscribed/_main/game-generator/$gameGeneratorId": {
      "filePath": "_authenticated/_subscribed/_main/game-generator/$gameGeneratorId.tsx",
      "parent": "/_authenticated/_subscribed/_main/game-generator"
    },
    "/_authenticated/_subscribed/play/custom-game/$gameId": {
      "filePath": "_authenticated/_subscribed/play/custom-game/$gameId.tsx",
      "parent": "/_authenticated/_subscribed/play"
    },
    "/_authenticated/_subscribed/play/game-generator/$gameGeneratorId": {
      "filePath": "_authenticated/_subscribed/play/game-generator/$gameGeneratorId.tsx",
      "parent": "/_authenticated/_subscribed/play"
    },
    "/_authenticated/_subscribed/script/$scriptId/dialog": {
      "filePath": "_authenticated/_subscribed/script.$scriptId/dialog.tsx",
      "parent": "/_authenticated/_subscribed/script/$scriptId"
    },
    "/_authenticated/_subscribed/_main/game-builder/": {
      "filePath": "_authenticated/_subscribed/_main/game-builder/index.tsx",
      "parent": "/_authenticated/_subscribed/_main"
    },
    "/_authenticated/_subscribed/_main/game-generator/": {
      "filePath": "_authenticated/_subscribed/_main/game-generator/index.tsx",
      "parent": "/_authenticated/_subscribed/_main/game-generator"
    },
    "/_authenticated/_subscribed/_main/home/": {
      "filePath": "_authenticated/_subscribed/_main/home/index.tsx",
      "parent": "/_authenticated/_subscribed/_main"
    },
    "/_authenticated/_subscribed/_main/my-scripts/": {
      "filePath": "_authenticated/_subscribed/_main/my-scripts/index.tsx",
      "parent": "/_authenticated/_subscribed/_main"
    },
    "/_authenticated/_subscribed/_main/subscription/": {
      "filePath": "_authenticated/_subscribed/_main/subscription/index.tsx",
      "parent": "/_authenticated/_subscribed/_main"
    },
    "/_authenticated/_subscribed/play/game-generator/": {
      "filePath": "_authenticated/_subscribed/play/game-generator/index.tsx",
      "parent": "/_authenticated/_subscribed/play"
    },
    "/_authenticated/_subscribed/script/$scriptId/": {
      "filePath": "_authenticated/_subscribed/script.$scriptId/index.tsx",
      "parent": "/_authenticated/_subscribed/script/$scriptId"
    }
  }
}
ROUTE_MANIFEST_END */
